import { style } from 'typestyle'
import { important } from 'csx'
export const ml4i = style({ marginLeft: important('4px') })
